
/* global csrf_token , timestamp , token , view , meer_informatie , in_ontwikkeling , global_formulier, is_refresh_bestandoverzicht:writable , sessie_beeindigd:writable, noConnection, DialogHandleError, DialogHandleSuccess, laadUploadifive, verlaatPagina, hoverTooltip */
import "./algemeen.wachtwoord";
import './_submenu';
import './_hoofdmenu';
import './react/utils/noConnection.ts';

function DialogHandleError(output) {
  $('html,body').animate({ scrollTop: 0 }, 'slow');
  $('#errorToast')
    .toast('show')
    .on('shown.bs.toast', function () {
      $('#toast-message').html(output);
    });
}

function DialogHandleSuccess(output) {
  $('html,body').animate({ scrollTop: 0 }, 'slow');
  $('#successToast')
    .toast('show')
    .on('shown.bs.toast', function () {
      $('#toast-message-success').html(output);
    });
}

$(document).on(
  'click',
  '#ik_wil_naar_mijn_overzicht,#overzichtknop',
  function () {
    location.href =
      '/index.php?view=consument.welkom&script_action=toon_persoonlijke_pagina&csrf_token=' +
      csrf_token;
  }
);

$(document).on('click', '#terugknop,#terugknop-2', function () {
  history.back();
});

$(document).on('click', '#agent_back_to_cms', function () {
  location.href =
    '/index.php?view=agent.werklijst&script_action=search&csrf_token=' +
    csrf_token;
});

$(document).on('click', '.taal', function () {
  const queryString = window.location.search.substring(1);
  const hashItem = window.location.hash;
  const baseLocation = window.location.href
    .replace(queryString, '')
    .replace(hashItem, '');
  const queries = queryString.split('&');
  const processedQueries = [];

  for (let i = 0; i < queries.length; i++) {
    if (queries[i].substring(0, 4) != 'taal') {
      processedQueries[processedQueries.length] = queries[i];
    }
  }

  const locationTarget =
    baseLocation +
    processedQueries.join('&') +
    '&taal=' +
    this.id +
    window.location.hash;

  //redirect
  location.href = locationTarget;
});

$(document).on('click', '.itje', function (event) {
  event.preventDefault(event);
  const content = $(this).find('#uitleg_itje').html();
  $('#itje').html(content).dialog({
    title: meer_informatie,
    resizable: false,
    height: 'auto',
    width: 350,
    modal: true,
  });
});

$('.details_polisblad').on('click', function (event) {
  event.preventDefault(event);
  const content = $(this).find('#details_polisblad').html();
  $('#itje').html(content).dialog({
    title: meer_informatie,
    resizable: false,
    width: 500,
    height: 'auto',
    modal: true,
  });
});

$('#in_ontwikkeling').on('click', function () {
  $('#dialog')
    .html(window.translator.t('functionaliteit_in_ontwikkeling'))
    .dialog({
      title: in_ontwikkeling,
      resizable: false,
      height: 240,
      modal: true,
      buttons: [
        {
          text: window.translator.t('knop_ok'),
          click: function () {
            $(this).dialog('close');
          },
        },
      ],
    });
});

function laadUploadifive() {
  $('#file_upload').fileupload({
    url: 'views/file.upload.php',
    maxFileSize: 10240000,
    formData: [
      { name: 'timestamp', value: timestamp },
      { name: 'token', value: token },
    ],
    dataType: 'json',
    progressall: function (e, data) {
      const progress = parseInt((data.loaded / data.total) * 100, 10);
      $('#progress .bar').css('width', progress + '%');
    },
    done: function (_e, _data) {
      if (view == 'consument.dialoog') {
        is_refresh_bestandoverzicht = 1;
        $(window).trigger('hashchange');
      } else {
        $('#dialog').dialog('close');
        $(
          '#' + global_formulier + '>#submit_open_formulier_bijlagen_opslaan'
        ).trigger('click');
      }
    },
  });
}

$(document).on('click', '.verwijder_bestand', function () {
  const bestand = this.id;
  const vraaggroep = $('#vraaggroep_id').val();
  const parameters =
    'script_action=verwijder_bestand&bestand=' +
    bestand +
    '&vraaggroep=34' +
    vraaggroep +
    '&csrf_token=' +
    csrf_token;
  $.post('/views/consument.dialoog.php', parameters, function () {
    if (view == 'consument.dialoog') {
      $(window).trigger('hashchange');
    } else {
      $('#dialog').dialog('close');
      $(
        '#' + global_formulier + ' > #submit_open_formulier_bijlagen_opslaan'
      ).trigger('click');
    }
  }).fail(function (_jqXHR, textStatus, errorThrown) {
    noConnection(textStatus, errorThrown);
  });
});

function verlaatPagina(view_) {
  let url = '';
  switch (view_) {
    case 'consument.dialoog':
      url = 'views/consument.dialoog.php?script_action=sluit_dialoogsessie';
      break;
    default:
      break;
  }

  if (url) {
    $.ajax({
      type: 'GET',
      url: url + '&csrf_token=' + csrf_token,
      async: false,
      success: function () {
        switch (view_) {
          case 'consument.dialoog':
            sessie_beeindigd = true;
            break;
          default:
            break;
        }
      },
    });
  }
}

/**
 * Opmerking Klaas-Jan: wordt alleen in gedragsanalyse gebruikt?
 * Roep deze functie aan om te zorgen dat een div met class .hover_sibling of .hover_child
 * tevoorschijn komt als er met de muis over de class .hover_me gaat.
 */
function hoverTooltip() {
  const offset = 10;
  const sibling = '.hover_sibling';
  const child = '.hover_child';
  $(document).on(
    {
      mouseenter: function (_e) {
        if ($(this).siblings(sibling).length !== 0) {
          $(this).siblings(sibling).css('display', 'inline-block');
        } else if ($(this).children(child).length !== 0) {
          $(this).children(child).css('display', 'inline-block');
        }
      },
      mouseleave: function (_e) {
        if ($(this).siblings(sibling).length !== 0) {
          $(this).siblings(sibling).hide();
        } else if ($(this).children(child).length !== 0) {
          $(this).children(child).hide();
        }
      },
      mousemove: function (e) {
        const popup =
          $(this).children(child).length !== 0
            ? $(this).children(child)
            : $(this).siblings(sibling).length !== 0
              ? $(this).siblings(sibling)
              : null;
        if (popup !== null) {
          if (popup.height() + e.pageY + offset >= $(document).height()) {
            popup.offset({
              left: e.pageX + offset,
              top: $(document).height() - popup.height() - offset,
            });
          } else {
            popup.offset({ left: e.pageX + offset, top: e.pageY + offset });
          }
        }
      },
    },
    '.hover_me'
  );
}

// Export all functions to global scope
window.DialogHandleError = DialogHandleError;
window.DialogHandleSuccess = DialogHandleSuccess;
window.laadUploadifive = laadUploadifive;
window.verlaatPagina = verlaatPagina;
window.hoverTooltip = hoverTooltip;
